var map = {
	"./1.jpg": "98a8",
	"./2.jpg": "593c",
	"./3.jpg": "6800",
	"./4.jpg": "ffd7",
	"./5.jpg": "546a",
	"./6.jpg": "129c",
	"./7.jpg": "2144",
	"./8.jpg": "017a",
	"./malte-wingen-PDX_a_82obo-unsplash.jpg": "16ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";